// 认证相关工具函数

export const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');
  
  // 检查是否有有效的token和userId
  if (!token || !userId) {
    // 如果缺少必要信息，清空所有认证数据
    clearAuthData();
    return false;
  }
  
  return true;
};

// 清空认证数据
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('isSuperAdmin');
  localStorage.removeItem('userId');
  sessionStorage.clear();
};

// 登录成功后跳转
export const loginSuccess = (token, isAdmin, userId, isSuperAdmin = false) => {
  localStorage.setItem('token', token);
  localStorage.setItem('isAdmin', isAdmin ? '1' : '0');
  localStorage.setItem('isSuperAdmin', isSuperAdmin ? '1' : '0');
  localStorage.setItem('userId', userId);
  // 使用强制刷新确保路由状态更新
  window.location.href = '/memos';
};

// 退出登录 - 清空所有认证信息
export const logout = () => {
  // 使用统一的清空函数
  clearAuthData();
  
  // 跳转到登录页
  window.location.href = '/login';
};

// 获取当前用户信息
export const getCurrentUser = () => {
  return {
    token: localStorage.getItem('token'),
    isAdmin: localStorage.getItem('isAdmin') === '1',
    isSuperAdmin: localStorage.getItem('isSuperAdmin') === '1',
    userId: localStorage.getItem('userId')
  };
};

// 权限检查函数
export const hasPermission = (permission) => {
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === '1';
  
  switch (permission) {
    case 'dashboard':
      return true; // 所有用户都可以访问
    case 'memo_read':
      return true; // 所有用户都可以查看
    case 'memo_write':
      return isAdmin; // 管理员和超级管理员可以编辑
    case 'ai_chat':
      return true; // 所有用户都可以使用
    case 'url_check':
      return isAdmin; // 管理员和超级管理员可以访问
    case 'user_management':
      return isAdmin; // 管理员和超级管理员可以访问
    case 'user_delete':
      return isSuperAdmin; // 只有超级管理员可以删除用户
    case 'user_super_admin':
      return isSuperAdmin; // 只有超级管理员可以设置超级管理员
    case 'super_admin':
      return isSuperAdmin; // 只有超级管理员
    case 'login_logs':
      return isSuperAdmin; // 只有超级管理员可以查看登录记录
    case 'system_settings':
      return isSuperAdmin; // 只有超级管理员可以访问系统设置
    default:
      return false;
  }
};

// 检查是否为普通用户
export const isNormalUser = () => {
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  return !isAdmin;
};

// 检查是否为管理员（非超级管理员）
export const isAdmin = () => {
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === '1';
  return isAdmin && !isSuperAdmin;
};

// 检查是否为超级管理员
export const isSuperAdmin = () => {
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === '1';
  return isSuperAdmin;
};

// 检查是否为管理员或超级管理员
export const isAdminOrSuperAdmin = () => {
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  return isAdmin;
}; 